import { type LeadPayload, submitLeadApi } from '@/api/lead'
import { validateLeadCoreFields } from '@/features/lead/validation'
import { AppError } from '@/shared/errors/appError'

export type SubmitLeadServiceResult = {
  ok: boolean
  message?: string
}

export async function submitLeadService(payload: LeadPayload): Promise<SubmitLeadServiceResult> {
  const validation = validateLeadCoreFields({
    name: payload.name,
    email: payload.email,
    phone: payload.phone,
  })

  if (!validation.ok) {
    throw new AppError(validation.message, { code: 'LEAD_VALIDATION_FAILED', status: 400 })
  }

  const result = await submitLeadApi(payload)

  if (!result.ok) {
    throw new AppError(result.message || 'Не удалось отправить заявку.', {
      code: 'LEAD_SUBMIT_FAILED',
    })
  }

  return {
    ok: true,
    message: result.message,
  }
}
